import { fetchReplenishmentTasksRoutine } from 'modules/replenishments/ducks/actions'

const defaultState = {
  list: [],
  pagination: null,
  isLoading: false
}

const replenishmentsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case fetchReplenishmentTasksRoutine.TRIGGER:
      return {
        ...state,
        isLoading: true
      }
    case fetchReplenishmentTasksRoutine.FAILURE:
      return {
        ...state,
        isLoading: false
      }
    case fetchReplenishmentTasksRoutine.SUCCESS:
      return {
        ...state,
        list: action.payload.data,
        pagination: {
          itemsCount: action.payload.meta.total,
          totalPages: action.payload.meta.lastPage,
          perPage: action.payload.meta.perPage,
          currentPage: action.payload.meta.currentPage
        },
        isLoading: false
      }
    default:
      return state
  }
}

export default replenishmentsReducer
